import type {
  CreateFamiliesEvent,
  FormErrorsEvent,
  FormEventDetails,
  ModalEventValue,
  TODO
} from '@/types'

export const createCustomPageViewEvent = (data: Record<string, TODO>) => ({
  event: 'CustomPageView',
  label: 'Page View',
  data
})

export const createCurrentFamilyEvent = (value: boolean) => ({
  event: 'current_family',
  label: 'Is Family chosen?',
  value,
  noninteraction: true
})

export const createSelectedProvinceEvent = (value: string) => ({
  event: 'selected_province',
  label: 'Current province name',
  value,
  action: 'click'
})

export const createChosenFamilyModalEvent = (value: ModalEventValue) => ({
  event: 'chosen_family_modal',
  label: 'Family was chosen',
  value,
  noninteraction: true
})

export const createUnavailableFamilyModalEvent = (value: ModalEventValue) => ({
  event: 'unavailable_family_modal',
  label: 'Family is not available in current location',
  value,
  noninteraction: true
})

export const createEmptyFamiliesListEvent = (value: CreateFamiliesEvent) => ({
  event: 'empty_families_list',
  label: 'Empty families list',
  value
})

export const createFormSubmitEvent = (value: FormEventDetails) => ({
  event: 'form_submit',
  action: 'click',
  label: 'Contact details send form',
  value
})

export const createFormErrorsEvent = (value: FormErrorsEvent) => ({
  event: 'form_errors',
  action: 'click',
  label: 'Contact details validation failed',
  value
})

export const createFamilyChosenEvent = (value: FormEventDetails) => ({
  event: 'family_chosen',
  label: 'Family was chosen',
  action: 'click',
  value
})
